"use strict";
import React from "react";
import { Modal } from "react-bootstrap";
import FormsyFields from "./formsyFields";
import Formsy from "./formsy";

const initComponent = (flex = window.flex) => {

    class Prompt extends React.PureComponent {
        constructor(props) {
            super(props);

            this.state = {
                canSubmit: true,
                formHandler: {},
                show: (typeof props.show === "undefined") ? true : props.show
            };
            this.submitBtnRef = React.createRef();
        }

        componentDidMount() {
            const props = this.props;
            flex.log(`PROMPT LAUNCHED: `, props);
        }

        close = () => {
            this.setState({ show: false });
            // pause for effect
            setTimeout(() => {
                const props = this.props;
                if (props.onClose) props.onClose();
                flex.prompt(false);
                flex.log(`PROMPT CLOSED: `, props);
            }, 300);
        };

        enableSubmit = () => { this.setState({ canSubmit: true }); };
        disableSubmit = () => { this.setState({ canSubmit: false }); };

        handleSubmit = (model, reset, invalidate) => {
            const props = this.props;
            const submitAction = _.find(props.actions, (action) => { return action.type.toLowerCase() === "submit" });
            const onSubmit = submitAction.handler;
            if (onSubmit) onSubmit(model, reset, invalidate, this.submitBtnRef.current);
            else this.close();

        };

        handleAction = (action, e) => {
            if (e && e.target) {
                var activeSpinner = flex.showSpinner(e.target);
            }

            if (action.handler) {
                action.handler(action);
            }
            else {
                this.close();
            }
        };

        render() {
            const me = this;
            const state = this.state;
            const show = state.show;
            const props = this.props;

            const actions = props.actions || [{ label: "Ok" }];
            const actionButtons =
                actions.map((action, index) => {
                    if (action.type == "submit") {
                        return (
                            <button key={`prompt-btn-${index}`} ref={this.submitBtnRef} type="submit" disabled={!this.state.canSubmit} className={action.default ? "btn btn-default" : "btn"}>{action.label}</button>
                        );
                    }
                    return (
                        <a key={`prompt-btn-${index}`} onClick={this.handleAction.bind(this, action)} className={action.type == "cancel" ? "btn btn-cancel" : "btn"}>{action.label}</a>
                    );
                });
            const additionalBodyClass = props.bodyClass || "";
            const formProps = { layout: "vertical" };
            const promptMatchError = props.promptMatchError || "Text does not match";
            const promptMatchMessage = !props.promptMatch ? false : props.promptMatchMessage || `Please type the following text to continue: ${props.promptMatch}`;
            const promptMatchControl = !props.promptMatch ? false :
                <fieldset style={{ marginTop: 20 }}>
                    <FormsyFields.Input {...formProps}
                        placeholder={props.promptMatch}
                        id="promptMatch"
                        name="promptMatch"
                        value=""
                        required={true}
                        type="text"
                        validations={{ matchRegexp: new RegExp(props.promptMatch, "i") }}
                        label={promptMatchMessage}
                        validationError={promptMatchError} />
                </fieldset>
            const footer = props.hideFooter ? false :
                <div>
                    {actionButtons}
                </div>

            return (
                <Modal show={show} onHide={this.close} backdrop="static" className={"modalComponent " + additionalBodyClass}>
                    <Formsy.Form style={{ textAlign: "left" }} onValidSubmit={me.handleSubmit} onValid={me.enableSubmit} onInvalid={me.disableSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title>{props.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ whiteSpace: 'pre-line' }}>
                            {props.message || "Are you sure?"}
                            {promptMatchControl}
                        </Modal.Body>
                        <Modal.Footer>
                            {footer}
                        </Modal.Footer>
                    </Formsy.Form>
                </Modal>
            );
        }
    }

    return Prompt;
};

module.exports = initComponent;
